import React from "react";
import { cutShort } from "../../../../utils/stringUtil";
import Box from "../../../../common/box/Box";
import FetchButton from "../../../../common/button/FetchButton";

function ReviewItem({ state, label, href, fileName = "", attached = false }) {
  return (
    <Box statusIndicatorPosition={"left"} statusIndicatorColor={attached ? "green" : "grey"}>
      <div className="level ">
        <div className="level-left level-item is-flex-shrink-1">{label}</div>
        <div className="level-right">
          {attached && (
            <Box
              defaultPadding={false}
              isBorderless={true}
              isShadowless={true}
              className={"p-1 has-background-white-ter is-size-7 is-small has-text-weight-bold"}
            >
              <FetchButton
                text={cutShort(fileName, 45, "...")}
                className={
                  "p-0 button has-background-white-ter is-size-7 is-white has-text-grey-dark has-text-weight-bold"
                }
                href={href}
              />
            </Box>
          )}
        </div>
      </div>
    </Box>
  );
}

export default ReviewItem;
